import Flex from 'common/components/Flex'
import Header from 'common/components/Header'
import Image from 'common/components/Image'
import Layout from 'common/components/Layout'
import Footer from 'common/components/MainFooter/RevampFooter'
import Typography from 'common/components/Typography'
import cdn from 'lib/cdn'

export default function NotFound(): JSX.Element {
  return (
    <Layout
      header={{ component: <Header /> }}
      footer={{ component: <Footer /> }}
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        margin="100px 0 auto"
      >
        <Image
          lazy
          width="410px"
          src={cdn({ path: '/assets/img/404.png' })}
        />
      </Flex>
      <Typography
        type="bh3"
        textAlign="center"
        marginBottom={153}
        marginTop={34}
      >
        Oops! Halaman Tidak Ditemukan
      </Typography>
    </Layout>
  )
}
